import React, { useState } from "react";
import { ChevronDown, ArrowRight } from "lucide-react";
import logoLight from "../../assets/cass-logo-light.png";

// Live mini header preview for the Navigation manager. Renders the *unsaved*
// working structure so CASS can see the real menu bar while dragging items.
export default function NavMenuPreview({ items }) {
  const [open, setOpen] = useState(null);

  const visible = (parent) =>
    items
      .filter((i) => (i.parent || "none") === parent && i.visible !== false)
      .sort((a, b) => (a.order || 0) - (b.order || 0));

  const top = visible("none").filter((i) => i.type !== "group" || visible(i.id).length || i.mega);

  return (
    <div className="mb-6" data-testid="nav-preview">
      <div className="flex items-center justify-between mb-2">
        <p className="text-xs font-bold uppercase tracking-wider text-slate-400">Live preview — how the menu bar will look</p>
        <p className="text-[11px] text-slate-400">Click a dropdown to peek inside. Hidden items aren't shown.</p>
      </div>

      <div className="rounded-2xl overflow-hidden border border-slate-200 shadow-sm">
        <div className="bg-navy px-5 h-16 flex items-center gap-5 overflow-x-auto">
          <img src={logoLight} alt="CASS" className="h-9 w-auto shrink-0" />
          {top.map((it) => {
            const kids = visible(it.id);
            const isGroup = it.type === "group";
            return (
              <div key={it.id} className="relative shrink-0">
                <button
                  type="button"
                  onClick={() => setOpen(open === it.id ? null : isGroup ? it.id : null)}
                  data-testid={`nav-preview-item-${it.id}`}
                  className={`flex items-center gap-1 text-xs font-semibold tracking-wide whitespace-nowrap transition-colors ${
                    open === it.id ? "text-orange" : "text-white hover:text-orange"
                  }`}
                >
                  {it.label || "Untitled"}
                  {isGroup && <ChevronDown size={13} className={open === it.id ? "rotate-180" : ""} />}
                </button>
              </div>
            );
          })}
          <span className="ml-auto shrink-0 inline-flex items-center gap-1.5 bg-orange text-white font-bold text-[11px] px-4 py-2 rounded-full">
            Let's Talk <ArrowRight size={12} />
          </span>
        </div>

        {open && (
          <div className="bg-white border-t border-slate-100 p-3" data-testid={`nav-preview-panel-${open}`}>
            <p className="text-[11px] font-bold uppercase tracking-wider text-orange mb-2">
              {(items.find((i) => i.id === open) || {}).label} dropdown
            </p>
            {items.find((i) => i.id === open)?.mega === "services" && (
              <p className="text-xs text-slate-400 mb-2">+ your live service list (managed in Services)</p>
            )}
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-1.5">
              {visible(open).map((c) => (
                <span key={c.id} className="flex items-center justify-between gap-2 px-3 py-2 rounded-lg bg-slate-50 text-xs font-medium text-navy">
                  {c.label || "Untitled"}
                  {c.badge && <span className="text-[9px] font-bold uppercase bg-orange/10 text-orange px-1.5 py-0.5 rounded">{c.badge}</span>}
                </span>
              ))}
              {!visible(open).length && <span className="text-xs text-slate-400 px-3 py-2">Nothing in here yet</span>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
